import { render, staticRenderFns } from "./DialogDetalhes.vue?vue&type=template&id=eaf512a8&scoped=true&"
import script from "./DialogDetalhes.vue?vue&type=script&lang=js&"
export * from "./DialogDetalhes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eaf512a8",
  null
  
)

export default component.exports